var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: _vm.$t("PAGE_CLIENTUSER_EMAIL"),
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: { close: _vm.onDialogClose },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "noticeemail-footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "cancel-btn",
                      attrs: { loading: _vm.loading },
                      on: { click: _vm.onCancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "cancel-btn",
                      attrs: { loading: _vm.loading },
                      on: { click: (e) => _vm.onConfirm(true) },
                    },
                    [_vm._v(_vm._s(_vm.$t("send_me_a_preview")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: (e) => _vm.onConfirm(false) },
                    },
                    [_vm._v(_vm._s(_vm.$t("comment_send")))]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "sas-noticeemail-container" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("recevier")) + "："),
            ]),
            _c(
              "el-select",
              {
                staticClass: "select",
                attrs: {
                  size: "mini",
                  multiple: "",
                  "collapse-tags": "",
                  disabled: _vm.loading,
                },
                model: {
                  value: _vm.emails,
                  callback: function ($$v) {
                    _vm.emails = $$v
                  },
                  expression: "emails",
                },
              },
              _vm._l(_vm.emailOptions, function (v, k) {
                return _c("el-option", {
                  key: k,
                  attrs: { label: v.userName, value: v.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("ccer")) + "："),
            ]),
            _c(
              "el-select",
              {
                staticClass: "select",
                attrs: {
                  size: "mini",
                  multiple: "",
                  "collapse-tags": "",
                  disabled: _vm.loading,
                },
                model: {
                  value: _vm.ccs,
                  callback: function ($$v) {
                    _vm.ccs = $$v
                  },
                  expression: "ccs",
                },
              },
              _vm._l(_vm.ccOptions, function (v, k) {
                return _c("el-option", {
                  key: k,
                  attrs: { label: v.userName, value: v.id },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }